import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";

function App() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [
    "/images/carousel-img1.png",
    "/images/carousel-img2.jpg",
    "/images/carousel-img3.png",
  ];

  useEffect(() => {
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 10000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div>
      <Helmet>
        <title>
          Bureau d'Étude & Économie de la Construction à Lyon - MOSA Ingénierie
        </title>
        <meta
          name="description"
          content="MOSA Ingénierie, bureau d’étude spécialisé en économie de la construction et maîtrise d’œuvre à Lyon. Contactez-nous pour vos projets."
        />
        <meta
          name="keywords"
          content="Bureau d'étude, Économie de la construction, Maîtrise d'œuvre, Lyon, MOSA Ingénierie"
        />
        <meta name="robots" content="index, follow" />
      </Helmet>
      {/* Hero Section */}
      <div className="bg-[#F2F2F2] flex justify-center items-center px-4 lg:px-24 py-20 lg:py-40 shadow-3xl">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row">
          <div className="w-full lg:w-1/2">
            <div className="p-4 lg:p-8">
              <h1 className="text-4xl lg:text-6xl font-bold mb-4 tracking-wider">
                <span className="text-[#0A827D]">L’économiste</span>
              </h1>
              <h1 className="text-4xl lg:text-6xl font-bold mb-4 tracking-wider">
                tout-terrain
              </h1>
              <p className="text-base lg:text-lg text-gray-700 mb-8 text-justify pt-4 tracking-wider">
                Nous vous accompagnons dans tous vos projets de construction, de
                la conception à la livraison.
              </p>
              <div className="flex flex-col lg:flex-row justify-evenly items-center">
                <a href="/apropos">
                  <button className="mr-0 lg:mr-4 mb-4 lg:mb-0 bg-[#0A827D] hover:bg-[#05736e] text-white font-bold py-3 px-5 shadow-lg transition-transform duration-300 hover:scale-110">
                    Nous découvrir
                  </button>
                </a>
                <button className="bg-[#60ac6d] hover:bg-[#407542] text-white font-bold py-3 px-5 shadow-lg transition-transform duration-300 hover:scale-110">
                  <a href="/contact">Nous contacter</a>
                </button>
              </div>
            </div>
          </div>

          {/* Carousel Section */}
          <div className="w-full lg:w-1/2">
            <div className="p-4 relative h-96">
              <img
                src={images[currentIndex]}
                alt={`Image${currentIndex + 1}`}
                className="w-full h-64 lg:h-full rounded-xl shadow-lg transition duration-500 ease-in-out transform"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Qui sommes-nous? Section */}
      <div className="bg-white shadow-3xl">
        <div className="flex flex-col lg:flex-row justify-center items-center">
          <div className="flex flex-col justify-center items-center w-full lg:w-1/2 px-4 lg:pl-24 lg:py-32 lg:pr-2 py-16">
            <div className="flex flex-col">
              <h1 className="text-[#0A827D] text-3xl lg:text-5xl font-bold text-center mb-8 tracking-wider">
                QUI SOMMES
              </h1>
              <h1 className="text-[#0A827D] text-3xl lg:text-5xl font-bold text-center mb-8 tracking-wider">
                NOUS ?
              </h1>
            </div>
            <p className="text-base lg:text-lg text-gray-700 text-center px-8 lg:px-40">
              Crée en 2021, MOSA Ingénierie vous accompagne dans tous vos
              projets de construction et/ou de rénovation.
            </p>
            <div className="flex flex-col lg:flex-row justify-evenly items-center pt-8">
              <a href="/apropos">
                <button className="mr-0 lg:mr-4 mb-4 lg:mb-0 bg-[#0A827D] hover:bg-[#05736e] text-white font-bold py-3 px-5 shadow-lg transition-transform duration-300 hover:scale-110">
                  Nous découvrir
                </button>
              </a>
              <button className="bg-[#60ac6d] hover:bg-[#407542] text-white font-bold py-3 px-5 shadow-lg transition-transform duration-300 hover:scale-110">
                <a href="/contact">Nous contacter</a>
              </button>
            </div>
            <img
              src="/images/workers.png"
              alt="workers"
              className="w-26 h-40 lg:w-32 lg:h-40 pt-8"
            />
          </div>
          <div className="w-full lg:w-1/2 bg-[#EBF5F5] px-4 lg:px-24 py-16 lg:py-40">
            <div className="flex flex-col lg:flex-row mb-8 lg:mb-16">
              <img
                src="/images/sarache.png"
                alt="Sara Fekih"
                className="w-24 h-24 lg:w-52 lg:h-52 rounded-full shadow-lg mx-auto lg:mx-0"
              />
              <div className="flex flex-col justify-center text-center lg:text-left mt-4 lg:mt-0 lg:pl-8">
                <h1 className="text-xl lg:text-2xl">
                  <b>Sara FEKIH</b>
                </h1>
                <p>Gérante</p>
                <p>Chef de projet</p>
                <p>Economiste de la construction</p>
              </div>
            </div>
            <div className="flex flex-col lg:flex-row mb-8 lg:mb-16">
              <img
                src="/images/moha.png"
                alt="Mohamed Fekih"
                className="w-24 h-24 lg:w-52 lg:h-52 rounded-full shadow-lg mx-auto lg:mx-0"
              />
              <div className="flex flex-col justify-center text-center lg:text-left mt-4 lg:mt-0 lg:pl-8">
                <h1 className="text-xl lg:text-2xl">
                  <b>Mohamed FEKIH</b>
                </h1>
                <p>Gérant</p>
                <p>Chef de projet</p>
                <p>Economiste de la construction</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className="bg-white shadow-3xl">
        <div className="flex flex-col lg:flex-row justify-center items-center">
          <div className="w-full lg:w-1/2 bg-[#EBF5F5] px-4 lg:px-24 py-16 lg:py-40 hidden lg:block">
            <div className="flex flex-col justify-end lg:flex-row mb-8 lg:mb-16">
              <img
                src="/images/service1.png"
                alt="Euro"
                className="w-24 h-24 lg:w-36 lg:h-36 rounded-full shadow-lg mx-auto lg:mx-0"
              />
              <div className="flex flex-col justify-center text-center lg:text-left mt-4 lg:mt-0 lg:pl-8">
                <h1 className="text-xl lg:text-2xl">
                  <b>Economiste de la </b>
                </h1>
                <h1 className="text-xl lg:text-2xl pb-2">
                  <b>construction</b>
                </h1>
                <p>Estimation financière et</p>
                <p>conseil d’optimisation</p>
              </div>
            </div>
            <div className="flex flex-col justify-end lg:flex-row mb-8 lg:mb-16">
              <img
                src="/images/service2.png"
                alt="maitrise d'oeuvre"
                className="w-24 h-24 lg:w-36 lg:h-36 rounded-full shadow-lg mx-auto lg:mx-0"
              />
              <div className="flex flex-col justify-center text-center lg:text-left mt-4 lg:mt-0 lg:pl-8">
                <h1 className="text-xl lg:text-2xl">
                  <b>Maitrise d’œuvre</b>
                </h1>
                <h1 className="text-xl lg:text-2xl pb-2">
                  <b>d’exécution</b>
                </h1>
                <p>Suivi de projet et gestion</p>
                <p>des entreprises</p>
              </div>
            </div>
            <div className="flex flex-col justify-end lg:flex-row mb-8 lg:mb-16">
              <img
                src="/images/service3.png"
                alt="Euro"
                className="w-24 h-24 lg:w-36 lg:h-36 rounded-full shadow-lg mx-auto lg:mx-0"
              />
              <div className="flex flex-col justify-center text-center lg:text-left mt-4 lg:mt-0 lg:pl-8">
                <h1 className="text-xl lg:text-2xl pb-2">
                  <b>
                    OPC <span style={{ color: "#EBF5F5" }}>ise d’œuvre</span>
                  </b>
                </h1>
                <p>Planification de projet et</p>
                <p>coordination des équipes</p>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center items-center w-full lg:w-1/2 px-2 lg:py-32 lg:pr-8 py-16">
            <div className="flex flex-col">
              <h1 className="text-[#0A827D] text-3xl lg:text-5xl font-bold text-center mb-8 tracking-wider">
                NOS METIERS
              </h1>
            </div>
            <p className="text-base lg:text-lg text-gray-700 text-center px-8 lg:px-40">
              Spécialisé dans l’économie de la construction et le suivi de
              chantier, nous vous accompagnons de la conception jusqu’à la
              livraison de votre projet.
            </p>
            <div className="flex flex-col lg:flex-row justify-evenly items-center pt-8">
              <a href="/metier">
                <button className="mr-0 lg:mr-4 mb-4 lg:mb-0 bg-[#0A827D] hover:bg-[#05736e] text-white font-bold py-3 px-5 shadow-lg transition-transform duration-300 hover:scale-110">
                  Nous découvrir
                </button>
              </a>
              <button className="bg-[#60ac6d] hover:bg-[#407542] text-white font-bold py-3 px-5 shadow-lg transition-transform duration-300 hover:scale-110">
                <a href="/contact">Nous contacter</a>
              </button>
            </div>
            <img
              src="/images/casque.png"
              alt="workers"
              className="w-24 h-24 lg:w-32 lg:h-32 pt-8"
            />
          </div>
        </div>
      </div>

      {/* Reference Section */}
      <div className="bg-[#F2F2F2] py-8 lg:py-16 shadow-3xl">
        <div className="flex justify-center items-center">
          <h1 className="text-[#0A827D] text-3xl lg:text-5xl font-bold text-center m-8 lg:m-16 tracking-wider">
            NOS REFERENCES
          </h1>
        </div>
        <div className="flex justify-center items-center py-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <div className="p-4 shadow-lg">
              <img
                src="/images/maison.png"
                alt="Maison"
                className="w-full h-52 object-cover"
              />
              <h1 className="text-lg font-bold pt-4 text-[#06837E]">HABITAT</h1>
              <p className="text-gray-700">Projet de logement collectif</p>
              <a href="/references">
                <button className="mr-0 lg:mr-4 bg-[#0A827D] hover:bg-[#05736e] text-white font-bold py-3 px-5 mt-2 shadow-lg transition-transform duration-300 hover:scale-110">
                  Découvrir
                </button>
              </a>
            </div>
            <div className="p-4 shadow-lg">
              <img
                src="/images/reference2.jpg"
                alt="hopital"
                className="w-full h-52 object-cover"
              />
              <h1 className="text-lg font-bold pt-4 text-[#06837E]">SANTE</h1>
              <p className="text-gray-700">Projet de bâtiment médicaux</p>
              <a href="/references">
                <button className="mr-0 lg:mr-4 bg-[#0A827D] hover:bg-[#05736e] text-white font-bold py-3 px-5 mt-2 shadow-lg transition-transform duration-300 hover:scale-110">
                  Découvrir
                </button>
              </a>
            </div>
            <div className="p-4 shadow-lg">
              <img
                src="/images/reference3.jpg"
                alt="Massage concept"
                className="w-full h-52 object-cover"
              />
              <h1 className="text-lg font-bold pt-4 text-[#06837E]">
                TERTIAIRE
              </h1>
              <p className="text-gray-700">Projet de commerce ou d’école</p>
              <a href="/references">
                <button className="mr-0 lg:mr-4 bg-[#0A827D] hover:bg-[#05736e] text-white font-bold py-3 px-5 mt-2 shadow-lg transition-transform duration-300 hover:scale-110">
                  Découvrir
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
